import { FC } from "react";
import { Outlet } from "react-router-dom";
import { CheckoutProvider } from "../../providers/Checkout/CheckoutProvider";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { UsersProvider } from "../../providers/Access/Users/UsersProvider";
import { CouponsProvider } from "../../providers/Financial/Coupons/CouponsProvider";

const stripeKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

if (!stripeKey) {
  throw new Error("Stripe key não definida");
}

const stripePromise = loadStripe(stripeKey);

export const CheckoutRoute: FC = () => {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutProvider>
        <UsersProvider>
          <CouponsProvider>
            <Outlet />
          </CouponsProvider>
        </UsersProvider>
      </CheckoutProvider>
    </Elements>
  );
};
